
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Breadcrumb from '../../components/feature/Breadcrumb';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/base/Button';

export default function Pricing() {
  const navigate = useNavigate();

  const inspectionPrices = [
    {
      category: '軽自動車',
      basicFee: '25,000',
      legalFee: '27,330',
      total: '52,330',
      details: ['法定24ヶ月点検', '検査手数料', '車検証発行']
    },
    {
      category: '普通車（小型）',
      basicFee: '30,000',
      legalFee: '45,340',
      total: '75,340',
      details: ['法定24ヶ月点検', '検査手数料', '車検証発行']
    },
    {
      category: '普通車（中型）',
      basicFee: '35,000',
      legalFee: '53,540',
      total: '88,540',
      details: ['法定24ヶ月点検', '検査手数料', '車検証発行']
    }
  ];

  const maintenancePrices = [
    { service: 'エンジンオイル交換', price: '3,000円〜', note: '※オイル代別途' },
    { service: 'オイルフィルター交換', price: '2,000円〜', note: '※部品代別途' },
    { service: 'ブレーキパッド交換', price: '8,000円〜', note: '※部品代別途' },
    { service: 'タイヤ交換（4本）', price: '3,000円〜', note: '※タイヤ代別途' },
    { service: 'バッテリー交換', price: '2,000円〜', note: '※バッテリー代別途' },
    { service: 'エアコン修理', price: '5,000円〜', note: '※診断料込み' }
  ];

  const bodyworkPrices = [
    { service: '小キズ修理', price: '15,000円〜', note: '※10cm以下' },
    { service: 'へこみ修理', price: '25,000円〜', note: '※手のひらサイズ' },
    { service: 'バンパー修理', price: '30,000円〜', note: '※塗装込み' },
    { service: 'ドア板金', price: '50,000円〜', note: '※塗装込み' },
    { service: '全塗装', price: '200,000円〜', note: '※車種により変動' },
    { service: '事故車修理', price: '要見積もり', note: '※現車確認後' }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      <Breadcrumb />
      <main className="pt-8">
        {/* Hero Section */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-slate-800 mb-6">
              車検・整備の費用目安
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              明確な料金体系で安心してご利用いただけます。<br />
              詳細なお見積もりは無料で承っております。
            </p>
          </div>
        </section>

        {/* Car Inspection Prices */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-slate-800 text-center mb-12">車検料金</h2>
            <div className="overflow-x-auto">
              <table className="w-full bg-white rounded-lg shadow-lg overflow-hidden">
                <thead className="bg-slate-800 text-white">
                  <tr>
                    <th className="px-6 py-4 text-left">車種</th>
                    <th className="px-6 py-4 text-center">車検基本料金</th>
                    <th className="px-6 py-4 text-center">法定費用</th>
                    <th className="px-6 py-4 text-center">合計目安</th>
                  </tr>
                </thead>
                <tbody>
                  {inspectionPrices.map((item, index) => (
                    <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                      <td className="px-6 py-4 font-medium text-slate-800">{item.category}</td>
                      <td className="px-6 py-4 text-center text-orange-600 font-bold">¥{item.basicFee}</td>
                      <td className="px-6 py-4 text-center">¥{item.legalFee}</td>
                      <td className="px-6 py-4 text-center text-lg font-bold text-slate-800">¥{item.total}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="mt-6 text-center">
              <p className="text-gray-600 mb-4">
                ※お車の状態により追加整備が発生する場合がございます。<br />
                ※法定費用には自賠責保険料、重量税、印紙代が含まれます。
              </p>
              <Button onClick={() => navigate('/contact')}>
                車検のお見積もり依頼
              </Button>
            </div>
          </div>
        </section>

        {/* Maintenance Prices */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-slate-800 text-center mb-12">一般整備料金</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {maintenancePrices.map((item, index) => (
                <div key={index} className="bg-white p-6 rounded-lg shadow-md">
                  <h3 className="text-lg font-bold text-slate-800 mb-2">{item.service}</h3>
                  <div className="text-2xl font-bold text-orange-600 mb-2">{item.price}</div>
                  <p className="text-sm text-gray-600">{item.note}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Bodywork Prices */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-slate-800 text-center mb-12">鈑金・塗装料金</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {bodyworkPrices.map((item, index) => (
                <div key={index} className="bg-gray-50 p-6 rounded-lg">
                  <h3 className="text-lg font-bold text-slate-800 mb-2">{item.service}</h3>
                  <div className="text-2xl font-bold text-orange-600 mb-2">{item.price}</div>
                  <p className="text-sm text-gray-600">{item.note}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Payment Options */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-slate-800 text-center mb-12">お支払い方法</h2>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
              {[
                { icon: 'ri-money-dollar-circle-line', title: '現金', description: '現金でのお支払い' },
                { icon: 'ri-bank-card-line', title: 'クレジットカード', description: 'VISA・Master・JCB' },
                { icon: 'ri-smartphone-line', title: '電子マネー', description: 'PayPay・楽天Pay' },
                { icon: 'ri-calendar-line', title: '分割払い', description: 'ローン対応可能' }
              ].map((payment, index) => (
                <div key={index} className="text-center">
                  <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className={`${payment.icon} text-3xl text-orange-500`}></i>
                  </div>
                  <h3 className="text-lg font-bold text-slate-800 mb-2">{payment.title}</h3>
                  <p className="text-gray-600">{payment.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 bg-slate-800 text-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-bold mb-4">
              詳細なお見積もりは無料です
            </h2>
            <p className="text-xl mb-8 text-gray-300 max-w-2xl mx-auto">
              お車の状態を確認の上、詳細なお見積もりを無料で作成いたします。<br />
              お気軽にお問い合わせください。
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button size="lg" onClick={() => navigate('/contact')}>
                無料見積もり依頼
              </Button>
              <Button 
                variant="outline" 
                size="lg"
                className="border-white text-white hover:bg-white hover:text-slate-800"
              >
                <i className="ri-phone-line mr-2"></i>
                0120-000-000
              </Button>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
